import { render, staticRenderFns } from "./intellidataDevice.vue?vue&type=template&id=2a04fc78&scoped=true&"
import script from "./intellidataDevice.vue?vue&type=script&lang=js&"
export * from "./intellidataDevice.vue?vue&type=script&lang=js&"
import style0 from "./intellidataDevice.vue?vue&type=style&index=0&id=2a04fc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04fc78",
  null
  
)

export default component.exports